export class DEVCHANGE {
    Type: string = "DEVCHANGE";
    SerialNumber: string;
    Name: string;
    StatusPiece : number;
}